import { Nil } from "../utils/types";
import { format } from "date-fns";
import { PhoneNumber } from "cy-models";

export function formatShortDate(date: string | number | Date | Nil) {
  return formatDate(date, "yyyy-MM-dd");
}

export function formatLongDate(date: string | number | Date | Nil) {
  return formatDate(date as Date, "EEEE do MMMM yyyy");
}

export function formatMediumDate(date: string | number | Date | Nil) {
  return formatDate(date as Date, "EEE do MMM yyyy");
}

/**
 * HTML date input value (YYYY-MM-DD) → UTC ISO at local start of day.
 * Intentionally uses the browser timezone: `new Date(y, m, d)` is local midnight, then `.toISOString()` converts to UTC.
 */
export function dateInputToUtcStart(dateValue: string): string {
  const [year, month, day] = parseDateInputValue(dateValue);
  return new Date(year, month - 1, day, 0, 0, 0, 0).toISOString();
}

/**
 * HTML date input value (YYYY-MM-DD) → UTC ISO at local end of day.
 * Intentionally uses the browser timezone: `new Date(y, m, d, 23, 59, 59, 999)` is local end of day, then `.toISOString()` converts to UTC.
 */
export function dateInputToUtcEnd(dateValue: string): string {
  const [year, month, day] = parseDateInputValue(dateValue);
  return new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
}

function parseDateInputValue(dateValue: string): [number, number, number] {
  const [year, month, day] = dateValue.split("-").map(Number);
  if (!year || !month || !day) {
    throw new Error(`Invalid date input value: ${dateValue}`);
  }
  return [year, month, day];
}

function formatDate(date: any, formatStr: string): any {
  if (!date) return "";
  const type = typeof date;
  if (type === "string" || type === "number") {
    date = new Date(date);
  }
  return format(date, formatStr);
}

export function formatPhoneNumber(phone: PhoneNumber | Nil) {
  if (!phone) {
    return "";
  }
  return `+${phone.isdCode} ${phone.number}`;
}
